export const getAllDistrictsSuccess = 'GET_ALL_DISTRICTS_SUCCESS';
export const getAllDistrictsStart = 'GET_ALL_DISTRICTS_START';
export const getAllDistrictsFail = 'GET_ALL_DISTRICTS_Fail';